import $ from 'jquery';
import React, { Fragment, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import Select from 'react-select';
import { PageContext } from '../../context/PageContext';
import { getApiPageUrl } from '../../utilities/urlHelper';
import { addSuccessMessage } from '../../utilities/notificationUtilities';
import { EVENTS } from '../../utilities/CONSTANTS';

class ChangePageOwner extends React.Component {
    static contextType = PageContext;

    state = {
        showModal: false,
        users: null,
        selectedOption: null,
        isSaving: null,
    };

    componentDidMount() {
        if (window._referencableTettraUsers) {
            return this.setUsers();
        }
        window.addEventListener(EVENTS.USERS_LOADED, this.setUsers);
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.USERS_LOADED, this.setUsers); }

    setUsers = () => {
        // Temporary for #6629
        if (!Array.isArray(window._referencableTettraUsers)) {
            console.error('user not defined', window._referencableTettraUsers);
            return;
        }
        const users = window._referencableTettraUsers
            .map(u => ({ value: u.id, label: u.display_name }))
            .filter(u => (u.value));

        return this.setState({ users });
    };

    getCurrentOwnerId = () => {
        const { isDraft, pageId } = this.props;
        if (isDraft) {
            return window._tettraDraft.owner_id;
        }
        if (pageId) {
            return null;
        }
        const { page } = this.context;
        return page.user_id;
    };

    getCurrentOwner = () => {
        const { users } = this.state;
        if (!users) return;
        const ownerId = this.getCurrentOwnerId();

        return users.find(u => (u.value == ownerId));
    };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            return this.setState({ showModal: false });
        }
    };

    onClickSave = () => {
        if (this.props.isDraft) {
            this.updateDraftOwner();
        } else if (this.props.pageId) {
            this.updatePageOwnerFromId();
        } else {
            this.updatePageOwner();
        }
    };

    updateDraftOwner = () => {
        const { selectedOption } = this.state;

        if (!selectedOption) {
            return this.setState({ showModal: false });
        }

        window._tettraDraft.owner_id = selectedOption.value;
        window.dispatchEvent(new Event(EVENTS.UPDATED_DRAFT_VALUES));

        return this.setState({ showModal: false });
    };

    updatePageOwnerFromId = () => {
        const { selectedOption } = this.state;

        if (!selectedOption) {
            return this.setState({ showModal: false });
        }

        this.setState({ isSaving: true });
        const url = getApiPageUrl(this.props.pageId);

        return $.ajax({
            type: 'PUT',
            url,
            data: { owner_id: selectedOption.value },
        }).then(({ success }) => {
            this.setState({ showModal: false, isSaving: false });

            if (success) {
                addSuccessMessage(`Page owner updated to ${selectedOption.label}`);

                if (this.props.onOwnerAssigned) {
                    this.props.onOwnerAssigned(this.props.pageId);
                }
            }
        });
    };

    updatePageOwner = () => {
        const { page, setPage } = this.context;
        const { selectedOption } = this.state;

        if (!selectedOption) {
            return this.setState({ showModal: false });
        }
        this.setState({ isSaving: true });
        const url = getApiPageUrl(page.id);

        return $.ajax({
            type: 'PUT',
            url,
            data: { owner_id: selectedOption.value },
        }).then(({ success }) => {
            addSuccessMessage(`Page owner updated to ${selectedOption.label}`);
            page.user_id = selectedOption.value;
            setPage(page);
            return this.setState({ showModal: false, isSaving: false });
        });
    };

    render() {
        const {
            showModal, users, selectedOption, isSaving,
        } = this.state;
        const owner = selectedOption || this.getCurrentOwner();
        const btnClass = !isSaving ? 'btn btn-primary' : 'btn btn-primary is-disabled';
        const btnText = !isSaving ? 'Save' : 'Saving...';

        // TODO: Refactor the whole ChangePageOwner component to functional component
        /* eslint-disable react/no-this-in-sfc */
        const ChangePageOwnerButton = (props) => {
            if (this.props.children) {
                return (
                    <span onClick={() => this.setState({ showModal: true })}>{this.props.children}</span>
                );
            }
            return (
                <span id="change-page-owner-modal" className="dropdown-option link" onClick={() => this.setState({ showModal: true })}>Change page owner</span>
            );
        };
        /* eslint-enable react/no-this-in-sfc */

        return (
            <Fragment>
                <ChangePageOwnerButton />
                { showModal && createPortal(
                    <div className="react-modal open" onMouseDown={this.onClickModal}>
                        <div className="modal-content p2">
                            <h2>Change page owner</h2>
                            { !users
                                ? <span className="grey loading">Loading</span>
                                : (
                                    <Select
                                        value={owner}
                                        onChange={(selectedOption) => this.setState({ selectedOption })}
                                        options={users}
                                    />
                                )}
                            <div className="right-align mt3">
                                <span className="btn-secondary mr1" onClick={() => this.setState({ showModal: false })}>Cancel</span>
                                <span className={btnClass} onMouseDown={this.onClickSave}>{btnText}</span>
                            </div>
                        </div>
                    </div>,
                    document.body,
                )}
            </Fragment>
        );
    }
}

export default ChangePageOwner;
